<template>
  <div class="text-center" data-cy="base-remove-button">
    <v-dialog v-model="dialog" width="auto " persistent>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          :icon="icon"
          :small="small"
          :disabled="disabled"
          data-cy="open-dialog-btn"
        >
          <v-icon
            :small="small"
            v-if="icon"
            :left="!icon"
            color="grey darken-1"
            v-bind="attrs"
            v-on="on"
            >mdi-delete</v-icon
          >
          {{ icon ? "" : title }}
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="headline background">
          {{ title }}
        </v-card-title>

        <v-divider></v-divider>
        <v-layout column justify-center align-center>
          <v-card-text style="height:100px">
            <p class="px-2">
              {{ i18n.t("__CFA1_DeleteItem") }}<br /><br />
              <strong v-if="!canUndo">{{ i18n.t("__CFA1_ApproveAction") }}</strong>
            </p>
          </v-card-text>
        </v-layout>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text @click="cancel" data-cy="btn-cancel">{{
            i18n.t("_Cancel")
          }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click="confirm" data-cy="btn-confirm">{{
            title
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import i18n from "../helper/i18n"
export default {
  props: {
    title: {
      type: String,
      required: true,
      default: function() {
        return "";
      }
    },

    canUndo: {
      type: Boolean,
      required: false,
      default: function() {
        return true;
      }
    },
    icon: {
      type: Boolean,
      required: false,
      default: function() {
        return false;
      }
    },
    small: {
      type: Boolean,
      required: false,
      default: function() {
        return false;
      }
    },
    disabled: {
      type: Boolean,
      required: false,
      default: function() {
        return false;
      }
    }
  },
  data() {
    return {
      dialog: false,
      i18n: i18n
    };
  },
  methods: {
    cancel() {
      this.dialog = false;
    },
    confirm() {
      this.dialog = false;
      this.$emit("canDo");
    }
  }
};
</script>

<style></style>
